import { useState } from "react";
import Utils from "../../lib/Utils";
import AccountsAPI from "../../lib/API/AccountsAPI";
import { v4 as uuidv4 } from "uuid";
import { Link, useHistory } from "react-router-dom";
import { BaseAxios } from "../../lib/API/AxiosInstances";

const Login = ({ header = false, message = 'Enter you email and password below', h100 = true, relaodOnLogin = false }) => {

    const history = useHistory();
    const [data, setData] = useState({
        email: null,
        password: null,
        connectionId : uuidv4()
    });
    const [loginFailed, setLoginFailed] = useState();

    const onChange = ({ target }) => {
        setData({ ...data, [target.name]: target.value });
    }

    const loginFailMessage = () => {
        switch (loginFailed){
            case "AccountInactive":
                return <span>You have to activate your account. <a className="btn btn-link p-0" onClick={resendConfirmation}>Resend email</a></span>
            default :
                return "Login Failed, please verify your email and password.";
            
        }
    }

    const resendConfirmation = () => {
        BaseAxios.post('user/resend-confirmation', { email : data.email })
            .then(() => history.push("/account/confirmation-sent"))
            .catch(() => alert('An error occured'));
    }

    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        AccountsAPI.login(data)
            .then(({ data : res }) => {
                setLoginFailed(false);
                Utils.SaveUser({...res.user, connectionId : data.connectionId});
                if(relaodOnLogin)
                    window.location.reload();
                else 
                    window.location.href = '/'
            })
            .catch((e) => {
                setLoginFailed(e.response?.data?.message);
            });
    }

    return (

        <div className={"mr-md-10" + (h100 ? ' h-100' : '')}>
            <form class={"d-flex flex-column" + (h100 ? ' h-100' : '')} onSubmit={onSubmit}>
                <div style={{ flex: 1 }}>
                    {header && <div className="login-header">Login</div>}
                    {loginFailed ? (
                        <div className="alert alert-danger text-center">
                            {loginFailMessage()}
                        </div>
                    ) : (
                        <p class="mt-3 text-center">{message}</p>
                    )}
                    <div className="form-group">
                        <label for="email">Email</label>
                        <input type="email" onChange={onChange} name="email" className="form-control" id="email" placeholder="Enter your email" />
                    </div>

                    <div className="form-group">
                        <label for="pwd">Password</label>
                        <input type="password" onChange={onChange} name="password" className="form-control" id="pwd" placeholder="Enter your password" />
                    </div>
                    <p><Link to={"/auth/reset-password"}>Forgot your password?</Link></p>
                </div>
                <div className="btns">
                    <button className="btn-yellow w-100">Login</button>
                </div>
            </form>
        </div>
    )
}

export default Login;